import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 1 * 60 * 1000, // 1 minute
      refetchOnWindowFocus: 'always',
    },
  },
});
